import { PLAYLIST_API_PATH } from 'constants/api';
import { ApiService } from 'service/api/apiService';
import { FetchResult } from 'type/apiType';
import { PlaylistInterface } from '../types/playlistType';

class PlaylistApiService {
  constructor(private apiService: ApiService<PlaylistInterface>) {}

  public async fetch(params?: URLSearchParams): Promise<FetchResult<PlaylistInterface>> {
    return this.apiService.fetch(params);
  }

  public async fetchById(id: number, params?: Record<string, string>): Promise<PlaylistInterface> {
    return this.apiService.fetchById(id, params);
  }

  public async create(playlist: PlaylistInterface): Promise<PlaylistInterface> {
    return await this.apiService.create(playlist);
  }

  public async update(id: number, playlist: PlaylistInterface): Promise<void> {
    await this.apiService.update(id, playlist);
  }
}

export const playlistApiService = new PlaylistApiService(
  new ApiService<PlaylistInterface>(PLAYLIST_API_PATH)
);
